<div class="wrapper">
  <div echarts [options]="options" (chartInit)="onChartInit($event)" class="chart"></div>
  <studio-button-legacy theme="transparent" class="actions-button">
    <studio-icon name="menu" size="32" title="Actions Menu"></studio-icon>
    <studio-popup-menu>
      <studio-popup-menu-item text="Download as image" (click)="downloadAsImageClicked()" />
      <studio-popup-menu-item text="Download as csv" (click)="downloadAsCsvClicked()" />
    </studio-popup-menu>
  </studio-button-legacy>
</div>
